export default __webpack_public_path__ + "static/135-ddac55dc35a71a44c1609aa3db359925.jpg";